export const FETCH_USER = 'FETCH_USER';
export const FETCH_CONTACT = 'FETCH_CONTACT';
export const LOGIN_USER = 'LOGIN_USER';
export const LOOK_UP_USER = 'LOOK_UP_USER';
export const LOG_OUT = 'LOG_OUT';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const UPDATE_USER = 'UPDATE_USER';

export enum UserActions {
    FETCH_USER = 'FETCH_USER',
    FETCH_CONTACT = 'FETCH_CONTACT',
    LOGIN = 'LOGIN_USER',
    LOOK_UP = 'LOOK_UP_USER',
    RECOVERY_PASSWORD = 'RECOVERY_PASSWORD',
    LOG_OUT = 'LOG_OUT',
    SET_USER_PROFILE = 'SET_USER_PROFILE',
    UPDATE_USER = 'UPDATE_USER',
}
